import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['wrapper', 'bar']

  connect() {
    this.align()
    window.addEventListener('resize', (this.alignBound = this.align.bind(this)))
  }

  disconnect() {
    window.removeEventListener('resize', this.alignBound)
  }

  align() {
    const wrapper = this.wrapperTarget
    const bar = this.barTarget

    if (!wrapper || !bar) return

    const overflows = bar.scrollWidth > wrapper.clientWidth
    bar.classList.remove('justify-start', 'justify-center')
    bar.classList.add(overflows ? 'justify-start' : 'justify-center')
  }
}
